module.exports = __webpack_public_path__ + "fonts/GoblinOne.cf83c13b.woff";